// Librarise
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Directives
import { ScrollToDirective } from './scroll-to.directive';
import { ScrollVisibleDirective } from './scroll-visibility.directive';

// Services
import { ScrollToService } from './scroll-to.service';

@NgModule({
  declarations: [
    ScrollToDirective,
    ScrollVisibleDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ScrollToDirective,
    ScrollVisibleDirective
  ],
  providers: [
    ScrollToService
  ]
})
export class ScrollToModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ScrollToModule
    };
  }
}
